import React, { lazy } from 'react';

const ContractCN = lazy(() =>
  import('../ClientContractListing/ClientContractListing').then(module => ({
    default: module.ClientContractListing,
  })),
);

const ContractLedgerForm = lazy(() =>
  import('../ClientContractForm/ContractCnForm').then(module => ({
    default: module.ContractCnForm,
  })),
);

const ContractLedgerDetail = lazy(() =>
  import('../ClientContractDetail/ContractCnDetail').then(module => ({
    default: module.ContractCnDetail,
  })),
);

const ContractLedgerMobileView = lazy(() =>
  import(
    '../../AccountLedgerModule/AccountLedgerMobileView/CreditNotePDF/CreditNotePDFMobile'
  ).then(module => ({
    default: module.CredMobile,
  })),
);

const ContractCreditNotesPreview = lazy(() =>
  import('../ClientContractPDF/CreditNotesPreviewDetailPDF').then(module => ({
    default: module.CreditNotesPreviewDetailPDF,
  })),
);

const ClientPreviewDetailPDF = lazy(() =>
  import('../ClientContractPDF/ClientPreviewDetailPDF').then(module => ({
    default: module.ClientPreviewDetailPDF,
  })),
);

const ContractLedgerAllocation = lazy(() =>
  import('../ClientContractListing/ClientContractAllocation').then(module => ({
    default: module.ClientContractAllocation,
  })),
);

const GLItemForm = lazy(() =>
  import('containers/SubconAccountModule/SubconForm/GLItemForm').then(
    module => ({
      default: module.GLItemForm,
    }),
  ),
);

export const ContractCNRoutes = [
  {
    props: {
      exact: true,
      path: `/contract/submenu/:contractID/account-status/credit-notes`,
    },
    component: (
      <ContractCN accountType="contract" transactionType="Credit Adjustment(CN Outwards)" />
    ),
  },
  {
    props: {
      exact: true,
      path: `/contract/submenu/:ID/account-status/credit-notes/detail/:transactionID`,
    },
    component: (
      <ContractLedgerDetail
        accountType="contract"
        transactionType="Credit Adjustment(CN Outwards)"
      />
    ),
  },
  {
    props: {
      exact: true,
      path: `/client-account/submenu/:ID/credit-notes`,
    },
    component: (
      <ContractCN accountType="client" transactionType="Credit Adjustment(CN Outwards)" />
    ),
  },
  {
    props: {
      exact: true,
      path: `/client-account/submenu/:ID/:contractID/credit-notes`,
    },
    component: (
      <ContractCN accountType="client" transactionType="Credit Adjustment(CN Outwards)" />
    ),
  },
  {
    props: {
      exact: true,
      path: `/client-account/submenu/:ID/:contractID/credit-notes/allocation/:transactionID`,
    },
    component: <ContractLedgerAllocation transactionType="Credit Adjustment(CN Outwards)" />,
  },
  {
    props: {
      exact: true,
      path: '/client-account/submenu/:ID/:contractID/credit-notes/add',
    },
    component: (
      <ContractLedgerForm
        transactionType="Credit Adjustment(CN Outwards)"
        accountType="client"
        formMode="add"
      />
    ),
  },
  {
    props: {
      exact: true,
      path: `/client-account/submenu/:ID/:contractID/credit-notes/:formMode/item/:itemMode`,
    },
    component: <GLItemForm transactionType="Credit Adjustment(CN Outwards)" />,
  },
  {
    props: {
      exact: true,
      path: `/client-account/submenu/:ID/:contractID/credit-notes/:formMode/:transactionID/item/:itemMode`,
    },
    component: <GLItemForm transactionType="Credit Adjustment(CN Outwards)" />,
  },
  {
    props: {
      exact: true,
      path: `/client-account/submenu/:ID/:contractID/credit-notes/:formMode/item/:itemMode/:itemID`,
    },
    component: <GLItemForm transactionType="Credit Adjustment(CN Outwards)" />,
  },
  {
    props: {
      exact: true,
      path: `/client-account/submenu/:ID/:contractID/credit-notes/:formMode/:transactionID/item/:itemMode/:itemID`,
    },
    component: <GLItemForm transactionType="Credit Adjustment(CN Outwards)" />,
  },
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/credit-notes/edit/:transactionID',
    },
    component: (
      <ContractLedgerForm
        transactionType="Credit Adjustment(CN Outwards)"
        accountType="client"
        formMode="edit"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/credit-notes/approve-reject/:transactionID',
    },
    component: (
      <ContractLedgerForm
        transactionType="Credit Adjustment(CN Outwards)"
        accountType="client"
        formMode="approve-reject"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/credit-notes/approve-reject/:refTable/workdesk/:transactionID',
    },
    component: (
      <ContractLedgerForm
        transactionType="Credit Adjustment(CN Outwards)"
        accountType="client"
        formMode="approve-reject"
        type="workdesk"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/credit-notes/resubmit/:transactionID',
    },
    component: (
      <ContractLedgerForm
        transactionType="Credit Adjustment(CN Outwards)"
        accountType="client"
        formMode="resubmit"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/credit-notes/detail/:transactionID',
    },
    component: (
      <ContractLedgerDetail
        transactionType="Credit Adjustment(CN Outwards)"
        accountType="client"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/credit-notes/detail/workdesk/:transactionID',
    },
    component: (
      <ContractLedgerDetail
        transactionType="Credit Adjustment(CN Outwards)"
        accountType="client"
        state="workdesk"
      />
    ),
  },
  /////////////////////////
  //// MOBILE PDF VIEW ////
  /////////////////////////
  {
    props: {
      exact: true,
      path: '/client-account/submenu/:ID/:contractID/credit-notes/mobile-view',
    },
    component: <ContractLedgerMobileView />,
  },
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/credit-notes/:transactionID/mobile-view',
    },
    component: <ContractLedgerMobileView />,
  },
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/credit-notes/:transactionID/preview',
    },
    component: (
      <ContractCreditNotesPreview
        transactionType="Credit Adjustment(CN Outwards)"
        accountType="client"
      />
    ),
  },
  /////////////////////ELETTER PREVIEW PDF///////////////
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/credit-notes/:creditNoteID/e-letter',
    },
    component: (
      <ClientPreviewDetailPDF
        docType="credit-note"
        accountType="client-account"
      />
    ),
  },
];
